<div class="container">
  <div class="header">
    <h1>Offline Patients</h1>
    <p class="text-muted">You are currently working offline. Only patients with downloaded data are available.</p>
    @if (this.offlineDataService.isInOfflineMode()) {
    <button class="side-menu-button2 me-3" (click)="goBackToOnline()" id="sideMenuButtonOffline">
      Go Back Online
    </button>
    }
  </div>

  <div class="reconnect-bar gap-3">
    <button class="btn btn-primary" (click)="tryReconnect()">
      <i class="pi pi-refresh"></i> Try to Reconnect
    </button>
    <button class="btn btn-primary" (click)="removeAllWithoutUnsynchedData()">
      <i class="pi pi-trash"></i> Remove all without unsynched data
    </button>
  </div>

  <div *ngIf="loading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading offline patients...</p>
  </div>

  <div *ngIf="errorMessage && !loading" class="alert alert-danger" role="alert">
    <strong>Warning:</strong> {{ errorMessage }}
  </div>

  <div *ngIf="!loading" class="patients-list">
    <div *ngIf="patients.length === 0" class="text-center my-5">
      <div class="empty-state">
        <i class="pi pi-cloud-off text-muted"></i>
        <p>No offline patients available.</p>
        <p class="text-muted">When online, use the download button on patient profiles to make them available offline.
        </p>
      </div>
    </div>

    <div *ngIf="patients.length > 0" class="row">
      <div *ngFor="let patientData of patients" class="col-md-6 col-lg-4 mb-4">
        <div class="card patient-card" (click)="selectPatient(patientData.patient)">
          <div class="card-body">
            <div class="patient-info">
              <div class="name-section">
                <h5 class="card-title mb-0">{{ patientData.patient.FirstName }} {{ patientData.patient.LastName }}</h5>
              </div>
              <div class="sync-info">
                <i class="pi pi-clock text-muted me-1"></i>
                <small class="text-muted">Last synced: {{ patientData.lastSyncTime | date:'MMM d, y, h:mm a'
                  }}</small>
              </div>
            </div>
            <div class="patient-actions">
              @if (patientHasOpenSessions(patientData)) {
                <div class="patient-status">
                  Sessions Available
                </div>
              }
              @if (!isOffline()) {
              @if (patientData.patient.ID) {
              <button class="btn btn-sm redownload-btn"
                (click)="redownloadPatientData(patientData.patient); $event.stopPropagation()"
                [disabled]="redownloading[patientData.patient.ID]">
                @if (redownloading[patientData.patient.ID]) {
                <i class="pi pi-spin pi-spinner me-1"></i>
                Re-downloading...
                } @else {
               
                <i class="pi pi-download me-1"></i>
                Re-download
                }
              </button>
              }
            }
            </div>
            
            <div class="patient-actions">
              @if (patientHasDirtySessions(patientData)) {
                <div class="patient-status bg-danger text-white">
                  Data to be synced
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
